import { render, staticRenderFns } from "./companyMobile.vue?vue&type=template&id=cdebab22&scoped=true&"
import script from "./companyMobile.vue?vue&type=script&lang=js&"
export * from "./companyMobile.vue?vue&type=script&lang=js&"
import style0 from "./companyMobile.vue?vue&type=style&index=0&id=cdebab22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdebab22",
  null
  
)

export default component.exports